// ----------------------------------------------------------------------


export default function Table(theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.neutral,
        },
        root: {
          padding:"10px",
        },
        // '& .MuiTableCell-root2':{
        //   padding:"10px",
        // },
      },
    },
  };
}
